import { useState } from 'react';
import RichTextEditor from '../../../components/RichTextEditor';
import { renderRichText } from '../../../utils/richText';

// Shared by both "heading" and "text" block types - they differ only in
// preview styling (h3 vs p) and default textarea size.
export default function TextBlockEditor({ block, onSave, onCancel }) {
   const [text, setText] = useState(block.text || '');
   const isHeading = block.type === 'heading';

   const handleSave = () => onSave({ text });

   return (
      <div className='exercise-block-text-editor'>
         <RichTextEditor value={text} onChange={setText} rows={isHeading ? 1 : 4}
            placeholder={isHeading ? 'Заголовок' : 'Текст. Виділіть слово, щоб оформити (жирний/курсив/підкреслення/закреслення/маркер)'} />
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderTextPreview(block) {
   const isHeading = block.type === 'heading';
   if(!block.text) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   const content = renderRichText(block.text);
   return isHeading ? <h3 className='exercise-block-heading-preview'>{content}</h3> : <div className='exercise-block-text-preview'>{content}</div>;
}
